import { useTranslation } from "react-i18next";
import Modal from "@components/common/Modal/Modal";
import ChangePasswordForm from "./components/ChangePasswordForm";

interface ChangePasswordModalProps {
	isOpen: boolean;
	onClose: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ isOpen, onClose }) => {
	const { t } = useTranslation();

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={t("psdaCommon.profile.changePassword.title")}
			width="max-w-lg"
			showCloseIcon>
			<ChangePasswordForm onSuccess={onClose} />
		</Modal>
	);
};

export default ChangePasswordModal;
